var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.333 5.889 3.444 2 2.333 3.111 6.222 7l-3.889 3.889L3.444 12l3.889-3.889L11.222 12l1.111-1.111L8.444 7l3.889-3.889L11.222 2z"
})));
export { SvgCloseIcon as ReactComponent };
export default __webpack_public_path__ + "0de6111633c8580c794a865c6e81af9b.svg";